module.exports = __webpack_public_path__ + "static/media/wysiwyg-icon-link.2c069a60.svg";